/** "" is a device with no fixed APN; null/undefined one that has not reported it. */
export const formatApn = (apn: string | null | undefined): string =>
  apn == null ? "Not reported yet" : apn === "" ? "Automatic (no fixed APN)" : apn;
